import ApplicationError from './ApplicationError';
export default class ResponseParseError extends ApplicationError {
    constructor(response, originalError, message = 'Get response parse error') {
        super(message);
        this.response = response;
        this.originalError = originalError;
        this.name = 'ResponseParseError';
    }
    toJSON() {
        const { name, message } = this;
        return {
            name,
            message,
        };
    }
}
